import { GENERIC_ACTION } from '../SearchResults/logic'

const ADD_PI_FOR_CT = 'ADD_PI_FOR_CT'
const ADD_PI_FOR_CT_SUCCESS = 'ADD_PI_FOR_CT_SUCCESS'
const ADD_PI_FOR_CT_RESET = 'ADD_PI_FOR_CT_RESET'
const ADD_PI_FOR_CT_FAILURE = 'ADD_PI_FOR_CT_FAILURE'

const INITIAL_STATE = {
  data: {},
  loading: false,
  error: false,
  flag: false,
}

export const addPiForCTAction = (payload, meta = {}) => {
  return ({
    type: GENERIC_ACTION,
    payload,
    meta: {
      actionType: ADD_PI_FOR_CT,
      url: `${process.env.apiUrl}v0/search/addpi`,
      method: 'POST',
      auth: true,
      log: false, // for console
      ...meta,
    },
    showNotification: true, // show notification on success
    message: 'Investigator added successfully',
    hideNotification: false, // hide notification on error
    // customErrMessage: 'PI already exists in the project results',
  })
}

export const addPiResetForCTAction = () => ({
  type: ADD_PI_FOR_CT_RESET,
})

export function addPiForCTReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_PI_FOR_CT: {
      return {
        data: {},
        loading: true,
        flag: false,
        error: false,
      }
    }
    case ADD_PI_FOR_CT_SUCCESS: {
      return {
        data: action.payload,
        loading: false,
        flag: true,
        error: false,
      }
    }
    case ADD_PI_FOR_CT_RESET: {
      return {
        data: {},
        loading: false,
        flag: false,
        error: false,
      }
    }
    case ADD_PI_FOR_CT_FAILURE: {
      return {
        data: action.payload,
        loading: false,
        flag: false,
        error: true,
      }
    }
    default:
      return state
  }
}
